var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('v-alert',{attrs:{"type":"warning","value":_vm.allManager}},[_vm._v(_vm._s(_vm.notes))]),_c('Departments',{attrs:{"biz":_vm.biz,"bizservice":_vm.bizservice}}),_c('Table',{attrs:{"biz":_vm.biz,"bizservice":_vm.bizservice}}),_c('Approval')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }